<template>
  <div class="columns is-multiline">
    <div class="column is-4">
      <b-field :label="$t('editionClient.divers.codeMagasin')">
        <b-input v-model="client.codeMagasin"></b-input>
      </b-field>
    </div>
    <div class="column is-4">
      <parametre-autocomplete
                  :label="$t('editionClient.divers.typePointVente')"
                  v-model="client.typePointVenteId"
                  :target="constantes.PARAMETRES_KEYS.typePointVente"
                  expanded
                />
    </div>
    <div v-if="moduleFactorActive" class="column is-4">
      <b-field :label="$t('editionClient.divers.codeMandataire')">
        <b-input v-model="client.numeroCedant"></b-input>
      </b-field>
    </div>
    <div class="column is-4">
      <b-field :label="$t('editionClient.divers.refExterne')">
        <b-input v-model="client.referenceExterne"></b-input>
      </b-field>
    </div>
    <div class="column is-4">
      <b-field :label="$t('editionClient.divers.dateAnniversaireContrat')">
        <b-datepicker show-week-number
          nearby-selectable-month-days
          v-model="client.dateAnniversaireContrat"
          icon="calendar-today"
          :editable="true">
        </b-datepicker>
      </b-field>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  components: {
    ParametreAutocomplete,
  },
  data() {
    return {
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleFactorActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleFactor.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typePointVente]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
